var generateStyle = function generateStyle() {
  return {
    labelWithHelp: {
      paddingRight: '2rem',
      position: 'relative'
    },
    helpButton: {
      position: 'absolute',
      top: '-0.25rem',
      right: 0
    }
  };
};
export default generateStyle;